import { Booking } from '../../../../APIDocs/apiTypes';
import { Label } from '../../components/Label';
import { CollapsibleCard } from '../../components/CollapsibleCard';

interface CancellationDetailsProps {
  booking: Booking;
  disableCollapse?: boolean;
}

export const CancellationDetailsCard = ({ booking, disableCollapse }: CancellationDetailsProps) => {
  if (!booking.CancellationParty && !booking.CancellationReason) return null;

  return (
    <CollapsibleCard identifier="cancellationDetails" title="Cancellation Details" disableCollapse={disableCollapse}>
      <Label title="Cancellation Party" text={booking.CancellationParty} />
      <Label title="Cancellation Notes" text={booking.CancellationReason} />
    </CollapsibleCard>
  );
};
